// M11: 率、比與變分 - Rates, Ratios and Variations
// 系統化數據結構，準備 Supabase 後端遷移

export const M11_MODULE_INFO = {
  moduleId: 'M11',
  title: '率、比與變分',
  titleEn: 'Rates, Ratios and Variations',
  description: '學習比率和變分的概念及應用',
  totalTopics: 6,
  estimatedTime: '6-8小時',
  difficulty: 'basic',
  prerequisites: ['M01', 'M05'],
  learningObjectives: [
    '理解比和比例的概念',
    '掌握正比例和反比例',
    '應用聯比例解決問題',
    '理解變分的實際意義',
    '解決比率相關應用題'
  ]
};

export const M11_TOPICS = [
  {
    id: 'M11_01',
    name: "比和比例基礎",
    description: "比和比例的基本概念和計算",
    order: 1,
    subTopics: [
      "比的定義和性質",
      "比例的基本概念",
      "比例的基本性質",
      "比例中項和第四比例項",
      "比例的應用問題"
    ]
  },
  {
    id: 'M11_02',
    name: "正比例",
    description: "正比例關係的理解和應用",
    order: 2,
    subTopics: [
      "正比例的定義",
      "正比例函數圖像",
      "正比例的性質",
      "正比例的實際應用",
      "正比例問題的建模"
    ]
  },
  {
    id: 'M11_03',
    name: "反比例",
    description: "反比例關係的分析和應用",
    order: 3,
    subTopics: [
      "反比例的定義",
      "反比例函數圖像",
      "反比例的性質",
      "反比例的實際應用",
      "反比例問題的建模"
    ]
  },
  {
    id: 'M11_04',
    name: "聯比例",
    description: "複合比例關係的處理",
    order: 4,
    subTopics: [
      "聯比例的概念",
      "正聯比例",
      "反聯比例",
      "混合聯比例",
      "聯比例的應用"
    ]
  },
  {
    id: 'M11_05',
    name: "變分應用",
    description: "變分在實際問題中的應用",
    order: 5,
    subTopics: [
      "變分的實際意義",
      "物理中的變分關係",
      "經濟中的變分應用",
      "幾何中的變分問題",
      "綜合變分應用"
    ]
  },
  {
    id: 'M11_06',
    name: "比率綜合應用",
    description: "比率在各領域的綜合應用",
    order: 6,
    subTopics: [
      "百分比與比率",
      "速度和效率問題",
      "相似圖形的比例",
      "金融中的比率應用",
      "統計中的比率概念"
    ]
  }
];

// 導出模組統計信息
export const M11_STATS = {
  totalTopics: M11_TOPICS.length,
  totalSubTopics: M11_TOPICS.reduce((sum, topic) => sum + topic.subTopics.length, 0),
  estimatedHours: 8,
  difficultyLevel: 1, // 1-3 scale
  prerequisiteModules: 2
}; 